module.exports = "/shared/img/rubbish-red.svg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/rubbish-red.svg
// module id = 447
// module chunks = 13